import React from "react";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import CurrencyFormat from 'react-currency-format';
import {Link} from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import {withStyles} from "@mui/styles";
import {currencySymbol} from "../../../../config/values";
import {useTranslation} from "react-i18next";
import {Wallet} from "lucide-react";

function MyWallet(props) {
    const classes = props.classes;
    const { t } = useTranslation();

    let amount = !!props.user ? props.user.wallet.amount : 0 ;
    return (
        <>
            <Tooltip title={t('balance')} arrow>
                <Button
                    color="inherit"
                    component={Link}
                    to={"/account/wallet"}
                    startIcon={<Wallet/>}
                    className={classes.menuWalletBtn}
                >
                    <CurrencyFormat value={amount} displayType={'text'} thousandSeparator={true}  suffix={` ${currencySymbol} `} style={{whiteSpace:'nowrap'}}/>

                </Button>
            </Tooltip>
        </>
    );
}
const mstp = state => ({
    user: state.user
});
export default withStyles(Styles)(connect(mstp)(MyWallet));
